import axios from 'axios'
import { URIS, loadHeaders } from '../Uris'
import { notify } from 'react-notify-toast'

import { exportqueueConstants, uiConstants } from '../constants'
import { uiHelper } from '../helpers'

export function exportData (payload) {
  return dispatch => {
    dispatch(doExport())
    axios({
      method: 'POST',
      url: URIS.export,
      headers: loadHeaders(),
      data: payload
    }).then(res => {
      dispatch(doExportSuccess(res.data))
      notify.show('Richiesta esportazione dati generata con successo', uiConstants.toast.success, 3000)
    }).catch(error => {
      dispatch(doExportFailure(uiHelper.responseMessage(error.response.status)))
      notify.show(uiHelper.responseMessage(error.response.status), uiConstants.toast.error, 3000)
      // if (error.response !== undefined) { dispatch(doSearchFailure(error.response.statusText)) } else { dispatch(doSearchFailure(error.message)) }
    })
  }
}

function doExport () {
  return {
    type: exportqueueConstants.DO_EXPORT
  }
}

function doExportSuccess (payload) {
  return {
    type: exportqueueConstants.DO_EXPORT_SUCCESS,
    payload
  }
}

function doExportFailure (payload) {
  return {
    type: exportqueueConstants.DO_EXPORT_FAILURE,
    payload
  }
}

export function checkExport () {
  return dispatch => {
    // dispatch(doExport())
    axios({
      method: 'GET',
      url: URIS.export,
      headers: loadHeaders()
    }).then(res => {
      const cr = res.data.filter(x => x.notified < 2)
      if (cr.length > 0) {
        notify.show('Ci sono dei file pronti per essere scaricati', uiConstants.toast.success, 3000)
      }
      dispatch(checkExportSuccess(res.data))
    }).catch(error => {
      dispatch(checkExportFailure(uiHelper.responseMessage(error.response.status)))
    })
  }
}

function checkExportSuccess (payload) {
  return {
    type: exportqueueConstants.CHECK_EXPORT_SUCCESS,
    payload
  }
}

function checkExportFailure (payload) {
  return {
    type: exportqueueConstants.CHECK_EXPORT_FAILURE,
    payload
  }
}
